(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .directive(
            'userSyncFilter', 
            [
                'UserSearchPaginationService',
                UserSyncFilterFn
            ]);

    function UserSyncFilterFn(
        UserSearchPaginationService) {
        const directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-sync-filter.template.html',
            scope: {
            }
        };
        return directive;

        function link(scope) {
            activate();

            scope.filterSyncActive = ($event) => {
                $event.stopPropagation();

                if (scope.syncActive !== null) {
                    scope.syncActive = !scope.syncActive;
                    if (scope.syncActive) {
                        scope.syncInactive = false;
                    }
                    scope.nonSyncedOnly = false;
                }

                refresh();
            };

            scope.filterSyncInactive = ($event) => {
                $event.stopPropagation();

                if (scope.syncInactive !== null) {
                    scope.syncInactive = !scope.syncInactive;
                    if (scope.syncInactive) {
                        scope.syncActive = false;
                    }
                    scope.nonSyncedOnly = false;
                }
                
                refresh();
            };
            
            scope.filterNonSyncedOnly = ($event) => {
                $event.stopPropagation();

                if (scope.nonSyncedOnly !== null) {
                    scope.nonSyncedOnly = !scope.nonSyncedOnly;
                    if (scope.nonSyncedOnly) {
                        scope.syncActive = false;
                        scope.syncInactive = false;
                    }
                }

                refresh();
            };
            
            function refresh() {
                if (!scope.syncActive && !scope.syncInactive) {
                    scope.syncedOnly = false;
                } else {
                    scope.syncedOnly = true;
                    scope.nonSyncedOnly = false;
                }
                
                UserSearchPaginationService.data.syncedOnly = scope.syncedOnly;
                UserSearchPaginationService.data.syncInactive = scope.syncInactive;
                UserSearchPaginationService.data.nonSyncedOnly = scope.nonSyncedOnly;

                UserSearchPaginationService.search();
                scope.numFilters = 
                    scope.syncActive +
                    scope.syncInactive + 
                    scope.nonSyncedOnly;
            }

            function activate() {
                scope.syncedOnly = UserSearchPaginationService.data.syncedOnly = false;
                scope.syncActive = false;
                scope.syncInactive = UserSearchPaginationService.data.syncInactive = false;
                scope.nonSyncedOnly = UserSearchPaginationService.data.nonSyncedOnly = false;
                scope.numFilters = 0;
            }
        }
    }
})();